const UniquelyYoursSection = () => {
  return (
    <section
      className="w-full px-4 md:px-16 py-12 md:py-20 flex items-center justify-center"
      style={{
        backgroundColor: '#F1F1F1',
        minHeight: '400px'
      }}
    >
      <div className="w-full flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-36 max-w-7xl">
        {/* First Column */}
        <div className="text-center w-full lg:w-auto lg:max-w-2xl">
          <h2
            className="text-3xl md:text-4xl lg:text-5xl mb-6 md:mb-8"
            style={{
              fontFamily: '"FONTSPRING DEMO - The Seasons", serif',
              color: '#764F2B',
              fontWeight: '400',
              textAlign: 'center'
            }}
          >
            Uniquely Yours.
          </h2>
          
          <p
            className="text-lg md:text-xl lg:text-2xl mb-6 md:mb-8 leading-relaxed"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#7b7b7b',
              textAlign: 'center'
            }}
          >
            The way we live, travel, and experience the world has evolved - and so have our expectations. FGA Prestige Concierge is here to meet them, offering seamless access to exceptional benefits tailored to your lifestyle, wherever you are. From exclusive reservations to bespoke escapes, our dedicated team can make it all happen - always with you in mind.
          </p>
          
          <p
            className="text-lg md:text-xl lg:text-2xl mb-6 md:mb-8 leading-relaxed"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#7b7b7b',
              textAlign: 'center'
            }}
          >
            We look forward to helping you experience the world in ways that feel uniquely yours.
          </p>
          
          <div className="text-center">
            <img
              src="/Landing Page/Unique yours/signature.png"
              alt="Signature"
              className="w-64 md:w-80 lg:w-96 h-auto mx-auto"
              style={{
                opacity: '0.8'
              }}
            />
          </div>
        </div>
        
        {/* Second Column */}
        <div className="text-center w-full lg:w-auto lg:max-w-sm mt-8 lg:mt-0">
          <div className="mb-4">
            <img
              src="/Landing Page/Unique yours/Sabrina C.png"
              alt="Sabrina C., Head of Client Management"
              className="w-64 md:w-80 lg:w-96 h-auto mx-auto"
              style={{
                maxWidth: '382px'
              }}
            />
          </div>
          
          <div className="text-center">
            <h3
              className="text-xl md:text-2xl mb-1"
              style={{
                fontFamily: 'Cardo, serif',
                color: '#764F2B',
                fontWeight: '400'
              }}
            >
              Sabrina C.
            </h3>
            <p
              className="text-xs font-semibold tracking-wider uppercase"
              style={{
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                color: '#000000'
              }}
            >
              FGA PRESTIGE, HEAD OF CLIENT MANAGEMENT
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default UniquelyYoursSection